module.exports = __webpack_public_path__ + "static/media/slider8img.c4c594f0.jpg";